import * as React from "react";

export class Label extends React.Component<{ label: string }, {}> {
    render() {
        return (
            <span className="rj-racing-future-events__arena">{this.props.label}</span>
        )
    }
}